// import { createContext, useContext, useState, useCallback } from 'react';
// import API from '../../axios/API';
// import { tickets as ticketsApi } from '../../api';
// import { DataContext } from '../DataProviders/DataProvider';

// const SupportContext = createContext();

// export const useSupportContext = () => {
//     const context = useContext(SupportContext);
//     if (!context) {
//         throw new Error('useSupportContext must be used within a SupportProvider');
//     }
//     return context;
// };

// export const SupportProvider = ({ children }) => {

//     const [sortValue, setSortValue] = useState(1);
//     const { userRole } = useContext(DataContext);
//     const [tickets, setTickets] = useState([]);
//     const [currentTicket, setCurrentTicket] = useState(null);
//     const [messages, setMessages] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [totalItems, setTotalItems] = useState(0);

//     /**
//     * Fetch tickets for customer or agent
//     * @param {number} id - customerId (for customers) or agentId (for admins)
//     * @param {string} status - status filter ("ALL" to fetch all)
//     * @param {number} page - page number (default: 1)
//     * @param {number} size - page size (default: 20)
//     */
//     const fetchTickets = useCallback(async (id, status = "ALL", page = 1, size = 20) => {
//         setLoading(true);
//         try {
//             const params = {
//                 filter: status,
//                 page: page - 1,
//                 size: size,
//                 sort: sortValue === 1 ? 'NEWEST_FIRST' : 'OLDEST_FIRST'
//             };

//             if (userRole === "ADMIN") {
//                 params.agentId = id;
//             } else {
//                 params.customerId = id;
//             }

//             const data = await ticketsApi.getBoard(undefined, params);

//             // Map the unified board response back to what the provider expects
//             const content = data.tickets || data.content || [];
//             const totalElements = data.totalTickets || data.totalElements || 0;

//             setTickets(content);
//             setTotalItems(totalElements);
//             return { success: true, data: { content, totalElements } };
//         } catch (error) {
//             console.error("Error fetching tickets via board API:", error);
//             return { success: false, error: "Unable to fetch tickets" };
//         } finally {
//             setLoading(false);
//         }
//     }, [userRole, sortValue]);

//     // Search tickets using API
//     const searchTickets = useCallback(async (keyword, page = 1, size = 20, customerId) => {
//         setLoading(true);
//         try {
//             const response = await API.get(`${import.meta.env.BACKEND_API}/ticket/ticket-search`, {
//                 params: {
//                     keyword,
//                     page: 1,
//                     size,
//                     customerId
//                 }
//             });

//             if (response.status === 200) {
//                 return { success: true, data: response.data };
//             } else {
//                 return { success: false, error: "Unable to search tickets" };
//             }
//         } catch (error) {
//             return { success: false, error: "Unable to search tickets" };
//         } finally {
//             setLoading(false);
//         }
//     }, []);

//     // Fetch single ticket with messages
//     const fetchTicket = useCallback(async (ticketNumber) => {
//         setLoading(true);
//         try {
//             const response = await API.get(`${import.meta.env.BACKEND_API}/ticket/${ticketNumber}`);

//             if (response.status === 200) {
//                 const ticketData = response.data;
//                 setCurrentTicket(ticketData);
//                 setMessages(ticketData.messages || []);
//                 return { success: true, data: ticketData };
//             } else {
//                 return { success: false, error: "Unable to fetch ticket" };
//             }
//         } catch (error) {
//             return { success: false, error: "Unable to fetch ticket" };
//         } finally {
//             setLoading(false);
//         }
//     }, []);

//     // Create new ticket — user-facing
//     // POST /api/v1/workspace/{workspaceId}/support/ticket
//     // ticketData shape: { requesterId, subject, description, issueCategoryId,
//     //                     channel, orderIds?, attachments? }
//     // Note: if files need to be attached, upload them first to get CDN URLs
//     //       and pass the URL array as ticketData.attachments.
//     const createTicket = useCallback(async (ticketData, workspaceId) => {
//         setLoading(true);
//         try {
//             const requesterId = ticketData.requesterId ?? ticketData.customerId ?? ticketData.userId;
//             const payload = {
//                 requesterId: requesterId,
//                 customerId: ticketData.customerId,
//                 subject: ticketData.subject,
//                 description: ticketData.description,
//                 issueCategoryId: ticketData.issueCategoryId ?? ticketData.issueTypeId ?? '',
//                 issueSubCategoryId: ticketData.issueSubCategoryId ?? '',
//                 channel: ticketData.channel ?? 'IN_APP',
//                 orderIds: ticketData.orderIds ?? [],
//                 attachments: ticketData.attachments ?? [],
//             };

//             const data = await ticketsApi.createTicket(payload, workspaceId);
//             return { success: true, data };
//         } catch (error) {
//             console.error('Error creating ticket:', error);
//             return { success: false, error: error.message ?? 'Ticket not created' };
//         } finally {
//             setLoading(false);
//         }
//     }, []);

//     // Reply to ticket
//     const replyToTicket = useCallback(async (replyData) => {
//         const { ticketId, message, userId, type, attachments } = replyData;

//         setLoading(true);


//         try {
//             const formData = new FormData();

//             const payload = {
//                 senderId: userId,
//                 senderRole: userRole === 'ADMIN' ? "AGENT" : "USER",
//                 message: message,
//                 type: type
//             };

//             formData.append("message", JSON.stringify(payload));
//             console.log(attachments)
//             if (attachments && attachments.length > 0) {
//                 attachments.forEach(file => {
//                     formData.append("file", file);
//                 });
//             }
//             console.log(formData)
//             const response = await API.post(
//                 `${import.meta.env.BACKEND_API}/ticket/message/${ticketId}`,
//                 formData,
//                 {
//                     headers: {
//                         'Content-Type': 'multipart/form-data'
//                     }
//                 }
//             );

//             if (response.status === 200) {
//                 return { success: true, data: response.data };
//             } else {
//                 return { success: false, error: "Unable to send reply" };
//             }
//         } catch (error) {
//             return { success: false, error: "Unable to send reply" };
//         } finally {
//             setLoading(false);
//         }
//     }, [userRole]);

//     // Mark ticket as read
//     const markAsRead = useCallback(async (ticketId) => {
//         try {
//             const response = await API.put(`${import.meta.env.BACKEND_API}/ticket/mark-as-read/${ticketId}`);
//             if (response.status === 200) {
//                 setTickets(prev => prev.map(t =>
//                     t.id === ticketId ? { ...t, hasUnread: false } : t
//                 ));
//                 return { success: true };
//             }
//         } catch (error) {
//             console.error('Error marking ticket as read:', error);
//             return { success: false, error: "Unable to mark as read" };
//         }
//     }, []);

//     // Clear current ticket data
//     const clearCurrentTicket = useCallback(() => {
//         setCurrentTicket(null);
//         setMessages([]);
//     }, []);

//     const value = {
//         // State
//         tickets,
//         currentTicket,
//         messages,
//         loading,
//         sortValue,
//         setSortValue,
//         // Actions
//         fetchTickets,
//         searchTickets,
//         fetchTicket,
//         createTicket,
//         replyToTicket,
//         markAsRead,
//         clearCurrentTicket,

//         // Setters (if needed for direct manipulation)
//         setTickets,
//         setCurrentTicket,
//         setMessages,
//         totalItems
//     };

//     return (
//         <SupportContext.Provider value={value}>
//             {children}
//         </SupportContext.Provider>
//     );
// };



import { createContext, useContext, useState, useCallback } from 'react';
import API from '../../axios/API';
import { DataContext } from '../DataProviders/DataProvider';

const SupportContext = createContext();

export const useSupportContext = () => {
    const context = useContext(SupportContext);
    if (!context) {
        throw new Error('useSupportContext must be used within a SupportProvider');
    }
    return context;
};

export const SupportProvider = ({ children }) => {

    const [sortValue, setSortValue] = useState(1);
    const { userRole } = useContext(DataContext);
    const [tickets, setTickets] = useState([]);
    const [currentTicket, setCurrentTicket] = useState(null);
    const [messages, setMessages] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalItems, setTotalItems] = useState(0);

    /**
    * Fetch tickets for customer or agent
    * @param {number} id - customerId (for customers) or agentId (for admins)
    * @param {string} status - status filter ("ALL" to fetch all)
    * @param {number} page - page number (default: 1)
    * @param {number} size - page size (default: 20)
    */
    const fetchTickets = useCallback(async (id, status = "ALL", page = 1, size = 20) => {
        setLoading(true);
        try {
            let url;

            if (userRole === "ADMIN") {
                // Admin/Agent → fetch assigned tickets
                url = `${import.meta.env.BACKEND_API}/ticket/agent/${id}/${status}?page=${page - 1}&size=${size}&sortBy=${(status === "REPLIES" || status === "ASSIGNED_TO_ME") ? "updatedAt" : "createdAt"}&direction=${sortValue === 1 ? 'desc' : 'asc'}`;
            } else {
                // Customer → fetch own tickets
                url = `${import.meta.env.BACKEND_API}/ticket/customer/${id}/${status}?page=${page - 1}&size=${size}&sortBy=${status === "REPLIES" ? "updatedAt" : "createdAt"}&direction=${sortValue === 1 ? 'desc' : 'asc'}`;
            }

            const response = await API.get(url);

            if (response.status === 200) {
                setTickets(response.data.content);
                setTotalItems(response.data.totalElements);
                return { success: true, data: response.data };
            } else {
                return { success: false, error: "Unable to fetch tickets" };
            }
        } catch (error) {
            return { success: false, error: "Unable to fetch tickets" };
        } finally {
            setLoading(false);
        }
    }, [userRole, sortValue]);

    // Search tickets using API
    const searchTickets = useCallback(async (keyword, page = 1, size = 20, customerId) => {
        setLoading(true);
        try {
            const response = await API.get(`${import.meta.env.BACKEND_API}/ticket/ticket-search`, {
                params: {
                    keyword,
                    page: 1,
                    size,
                    customerId
                }
            });

            if (response.status === 200) {
                return { success: true, data: response.data };
            } else {
                return { success: false, error: "Unable to search tickets" };
            }
        } catch (error) {
            return { success: false, error: "Unable to search tickets" };
        } finally {
            setLoading(false);
        }
    }, []);

    // Fetch single ticket with messages
    const fetchTicket = useCallback(async (ticketNumber) => {
        setLoading(true);
        try {
            const response = await API.get(`${import.meta.env.BACKEND_API}/ticket/${ticketNumber}`);

            if (response.status === 200) {
                const ticketData = response.data;
                setCurrentTicket(ticketData);
                setMessages(ticketData.messages || []);
                return { success: true, data: ticketData };
            } else {
                return { success: false, error: "Unable to fetch ticket" };
            }
        } catch (error) {
            return { success: false, error: "Unable to fetch ticket" };
        } finally {
            setLoading(false);
        }
    }, []);

    // Create new ticket using the port 4000 endpoint
    const createTicket = useCallback(async (ticketData) => {
        setLoading(true);
        try {
            const formData = new FormData();

            // Append text fields
            formData.append('title', ticketData.subject);
            formData.append('description', ticketData.description);
            formData.append('affectedUserOptions', ticketData.affectedUsers);
            formData.append('companyName', ticketData.companyName);
            formData.append('customerId', ticketData.customerId);
            formData.append('userId', ticketData.userId);
            formData.append('assignedAgentId', ticketData.assignedAgentId);

            // ✅ New fields for issue type integration
            // New fields
            if (ticketData.issueType) {
                formData.append('issueType', ticketData.issueType);
            }
            if (ticketData.issueTypeId) {
                formData.append('issueTypeId', ticketData.issueTypeId);
            }
            if (ticketData.issueTypeDescription) {
                formData.append('issueTypeDescription', ticketData.issueTypeDescription);
            }

            // Append file if exists
            if (ticketData.file) {
                formData.append('file', ticketData.file);
                formData.append('key', ticketData.file.name);
            }

            const response = await API.post(`${import.meta.env.BACKEND_API}/ticket`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            if (response.status === 200 || response.status === 201) {
                return { success: true, data: response.data };
            } else {
                return { success: false, error: "Ticket not created successfully" };
            }
        } catch (error) {
            console.error('Error creating ticket:', error);
            return { success: false, error: "Ticket not created " };
        } finally {
            setLoading(false);
        }
    }, []);

    // Reply to ticket
    const replyToTicket = useCallback(async (replyData) => {
        const { ticketId, message, userId, type, attachments } = replyData;

        setLoading(true);


        try {
            const formData = new FormData();

            const payload = {
                senderId: userId,
                senderRole: userRole === 'ADMIN' ? "AGENT" : "USER",
                message: message,
                type: type
            };

            formData.append("message", JSON.stringify(payload));
            console.log(attachments)
            if (attachments && attachments.length > 0) {
                attachments.forEach(file => {
                    formData.append("file", file);
                });
            }
            console.log(formData)
            const response = await API.post(
                `${import.meta.env.BACKEND_API}/ticket/message/${ticketId}`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );

            if (response.status === 200) {
                return { success: true, data: response.data };
            } else {
                return { success: false, error: "Unable to send reply" };
            }
        } catch (error) {
            return { success: false, error: "Unable to send reply" };
        } finally {
            setLoading(false);
        }
    }, [userRole]);

    // Mark ticket as read
    const markAsRead = useCallback(async (ticketId) => {
        try {
            const response = await API.put(`${import.meta.env.BACKEND_API}/ticket/mark-as-read/${ticketId}`);
            if (response.status === 200) {
                setTickets(prev => prev.map(t =>
                    t.id === ticketId ? { ...t, hasUnread: false } : t
                ));
                return { success: true };
            }
        } catch (error) {
            console.error('Error marking ticket as read:', error);
            return { success: false, error: "Unable to mark as read" };
        }
    }, []);

    // Clear current ticket data
    const clearCurrentTicket = useCallback(() => {
        setCurrentTicket(null);
        setMessages([]);
    }, []);

    const value = {
        // State
        tickets,
        currentTicket,
        messages,
        loading,
        sortValue,
        setSortValue,
        // Actions
        fetchTickets,
        searchTickets,
        fetchTicket,
        createTicket,
        replyToTicket,
        markAsRead,
        clearCurrentTicket,

        // Setters (if needed for direct manipulation)
        setTickets,
        setCurrentTicket,
        setMessages,
        totalItems
    };

    return (
        <SupportContext.Provider value={value}>
            {children}
        </SupportContext.Provider>
    );
};